/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: ep0w6NE2omrP
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicButtonNav2.module.css"; // plasmic-import: ep0w6NE2omrP/css
import image9EWfdMifWljwe from "./images/image9.svg"; // plasmic-import: eWFDMifWLJWE/picture

createPlasmicElementProxy;

export const PlasmicButtonNav2__VariantProps = new Array(
  "shape",
  "slotSize",
  "status",
  "color"
);

export const PlasmicButtonNav2__ArgProps = new Array(
  "iconForButton",
  "onClick",
  "disabled",
  "name"
);

const $$ = {};

function PlasmicButtonNav2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "shape",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.shape
      },
      {
        path: "slotSize",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.slotSize
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_greyOne]: hasVariant($state, "color", "greyOne"),
          [sty.rootcolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.rootcolor_white]: hasVariant($state, "color", "white"),
          [sty.rootshape_fullRounding]: hasVariant(
            $state,
            "shape",
            "fullRounding"
          ),
          [sty.rootshape_globalRounding]: hasVariant(
            $state,
            "shape",
            "globalRounding"
          ),
          [sty.rootslotSize_fillButton]: hasVariant(
            $state,
            "slotSize",
            "fillButton"
          ),
          [sty.rootstatus_disabled]: hasVariant($state, "status", "disabled")
        }
      )}
      disabled={(() => {
        try {
          return $props.disabled;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      name={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__cUk8Z)}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={{
              src: image9EWfdMifWljwe,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.iconForButton
      })}
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonNav2__ArgProps,
          internalVariantPropNames: PlasmicButtonNav2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonNav2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButtonNav2";
  } else {
    func.displayName = `PlasmicButtonNav2.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonNav2 = Object.assign(
  // Top-level PlasmicButtonNav2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicButtonNav2
    internalVariantProps: PlasmicButtonNav2__VariantProps,
    internalArgProps: PlasmicButtonNav2__ArgProps
  }
);

export default PlasmicButtonNav2;
/* prettier-ignore-end */
